/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_KindleInputs */

const en_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Kindle (.epub)`)
};

const es_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar Kindle (.epub)`)
};

const fr_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter Kindle (.epub)`)
};

const de_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindle exportieren (.epub)`)
};

const ja_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindleエクスポート (.epub)`)
};

const zh_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出 Kindle (.epub)`)
};

const ar_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصدير إلى كيندل (.epub)`)
};

const id_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekspor Kindle (.epub)`)
};

const it_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta Kindle (.epub)`)
};

const ru_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт Kindle (.epub)`)
};

const pt_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar Kindle (.epub)`)
};

const ko_export_kindle = /** @type {(inputs: Export_KindleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindle 내보내기 (.epub)`)
};

/**
* | output |
* | --- |
* | "Export Kindle (.epub)" |
*
* @param {Export_KindleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const export_kindle = /** @type {((inputs?: Export_KindleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_KindleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_kindle(inputs)
	if (locale === "es") return es_export_kindle(inputs)
	if (locale === "fr") return fr_export_kindle(inputs)
	if (locale === "de") return de_export_kindle(inputs)
	if (locale === "ja") return ja_export_kindle(inputs)
	if (locale === "zh") return zh_export_kindle(inputs)
	if (locale === "ar") return ar_export_kindle(inputs)
	if (locale === "id") return id_export_kindle(inputs)
	if (locale === "it") return it_export_kindle(inputs)
	if (locale === "ru") return ru_export_kindle(inputs)
	if (locale === "pt") return pt_export_kindle(inputs)
	return ko_export_kindle(inputs)
});